import { render } from "./FileUpload.vue?vue&type=template&id=bff96d34&scoped=true"
import script from "./FileUpload.js?vue&type=script&lang=js&external"
export * from "./FileUpload.js?vue&type=script&lang=js&external"

import "./FileUpload.css?vue&type=style&index=0&id=bff96d34&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff96d34"]])

export default __exports__